import { searchExamResult,checkcCertificate } from "@/request/certificate"
import { message } from 'ant-design-vue'

export default {
    namespaced:true,
    state:{
        certificateNumber:'',
        examResultList:[],
        checkresult:[],
        checkresultimage:"",
        iscaptcha:true,
        hasResult:false,
        isCorrect:true,
        cansearch:false
    },
    getters:{
        checkresult:(state:any) => state.checkresult,
        checkresultimage:(state:any) => state.checkresultimage,
        hasResult:(state:any) => state.hasResult,
        iscaptcha:(state:any) => state.iscaptcha,
        isCorrect:(state:any) => state.isCorrect,
        cansearch:(state:any) => state.cansearch,
        certificateNumber:(state:any) => state.certificateNumber,
        examResultList:(state:any) => state.examResultList,
    },
    mutations:{
        SET_CHECKRESULT(state:any,data:any){
            state.checkresult = data
        },
        SET_CHECKRESULTIMAGE(state:any,data:any){
            state.checkresultimage = data
        },
        SET_HASRESULT(state:any,data:boolean){
            state.hasResult = data
        },
        SET_ISCAPTCHA(state:any,data:boolean){
            state.iscaptcha = data
        },
        SET_ISCORRECT(state:any,data:boolean){
            state.isCorrect = data
        },
        SET_CANSEARCH(state:any,data:any){
            state.cansearch = data
        },
        SET_SEARCHLIST(state:any,data:any){
            state.examResultList = data
        },
        SET_CERTNUM(state:any,data:any){
            state.certificateNumber = data
        }
    },
    actions:{
        async get_check_result({state,commit}:any,data:any){
            return await checkcCertificate(data);
            
        },
        async SearchExamResult({state,commit}:any){
            let token = localStorage.getItem("token")? JSON.parse((localStorage as any).getItem("token")): "";
            let res = await searchExamResult(token);
            console.log(res);
            
            if(res.data.code == 0){
                if(res.data.examResultList){
                    if (res.data.examResultList.length > 0) {
                        const time:any = new Date().getTime();
                        let endTime:any = ""; //定义证书到期时间
                        res.data.examResultList.forEach((item:any) => {
                            endTime = new Date(item.endTime).getTime();
                            //判断证书到期时间是否是0,
                            if (endTime == 0) {
                               item.states = ""; //状态为空
                            } else {
                               //不为0当前时间大于到期时间显示过.期
                               if (time > endTime) {
                                item.statusName = "过期";
                               } else if (time <= endTime) {
                                //当前时间小于等于到期时间为有效
                                item.statusName = "通过";
                               }
                            }
                        })
                        commit('SET_SEARCHLIST',res.data.examResultList) ;
                        commit('SET_CERTNUM',state.examResultList[0].certificateNumber)
                    }else{
                       message.error("该用户没有证书数据")
                    }
                }
            } else if(res.data.code == 401){
                message.error('token过期')
            }else{
                message.error(res.data.msg)
            }
            
            
        }
    }
}